// Both exported checks are serialized into static homepage HTML by
// createHomeSessionRedirectScript. Keep them self-contained: imported helpers
// and module-level constants are unavailable there. After changing either,
// run home-session-redirect-script.test.ts and the compiled test:ssr lane.
/** A hint to start Privy, never proof of authentication or signing authority. */
export function hasPrivySessionHint(): boolean {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  try {
    if (
      document.cookie.split(";").some((cookie) => {
        const [name, ...value] = cookie.trim().split("=");
        return name === "privy-session" && value.join("=").trim() !== "";
      })
    )
      return true;
  } catch {
    // Browser privacy settings can make cookie access unavailable.
  }

  try {
    const readCredential = (key: string): string | null => {
      const stored = window.localStorage.getItem(key);
      if (stored === null) return null;
      const value: unknown = JSON.parse(stored);
      return typeof value === "string" && value.trim() !== "" ? value : null;
    };
    // Privy 3 also supports sessions predating its readable cookie. Its
    // refresh flow needs both a stored access token and refresh credential;
    // an expired access token can still be refreshed, so do not decode it.
    const refresh = readCredential("privy:refresh_token");
    return (
      refresh !== null &&
      refresh !== "deprecated" &&
      (readCredential("privy:pat") !== null ||
        readCredential("privy:token") !== null)
    );
  } catch {
    return false;
  }
}

export function hasPrivyOAuthCallback(): boolean {
  if (typeof window === "undefined") return false;
  const search = new URLSearchParams(window.location.search);
  return Boolean(
    search.get("privy_oauth_code") &&
    search.get("privy_oauth_state") &&
    search.get("privy_oauth_provider"),
  );
}
